import { z } from "zod"

export const ReviewSchema = z.object({
  jobId: z.string().uuid(),
  rating: z.number().min(1).max(5),
  comment: z.string().nullable(),
  storeResponse: z.string().nullable(),
  storeResponseRespondedAt: z.date().nullable(),
  createdAt: z.date(),
})

export const SaveReviewSchema = ReviewSchema.omit({
  createdAt: true,
  storeResponse: true,
  storeResponseRespondedAt: true,
}).extend({
  // Optional for clients still on the build that sent questionsAndAnswers.
  comment: z.string().nullable().optional(),
})

export const MarketplaceReviewSchema = ReviewSchema.extend({
  id: z.string().uuid(),
  customerFirstName: z.string(),
  updatedAt: z.date(),
})

export const PublicReviewSchema = z.object({
  id: z.string().uuid(),
  rating: z.number().min(1).max(5),
  customerFirstName: z.string(),
  publicComment: z.string(),
  storeResponse: z.string().nullable(),
  storeResponseRespondedAt: z.date().nullable(),
  createdAt: z.date(),
})

export const RespondToReviewSchema = z.object({
  storeResponse: z.string().trim().min(1).max(2000),
})

export type SaveReview = z.infer<typeof SaveReviewSchema>
export type Review = z.infer<typeof ReviewSchema>
export type MarketplaceReview = z.infer<typeof MarketplaceReviewSchema>
export type PublicReview = z.infer<typeof PublicReviewSchema>
export type RespondToReview = z.infer<typeof RespondToReviewSchema>

export interface PaginatedPublicReviews {
  items: PublicReview[]
  totalCount: number
  page: number
  pageSize: number
}
